module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_5012.41ade23c.png";